import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import CbmCalculator from '../components/CbmCalculator';
import heroBg from '../assets/auth/logistics-hero.png';
import '../styles/services-page.css';

const CbmCalculatorPage = () => {
  return (
    <div className="svc-page">
      <section className="svc-hero" aria-labelledby="svc-cbm-title">
        <div className="svc-hero__bg" style={{ backgroundImage: `url(${heroBg})` }} />
        <div className="svc-hero__overlay" />
        <div className="svc-hero__inner">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45 }}>
            <p className="svc-hero__crumb">
              <Link to="/">Home</Link>
              <span aria-hidden> &gt; </span>
              <Link to="/services">Services</Link>
              <span aria-hidden> &gt; </span>
              CBM calculator
            </p>
            <h1 id="svc-cbm-title" className="svc-hero__title">
              <em>CBM</em> calculator
            </h1>
            <p className="svc-hero__lead">
              Estimate cubic meters (m³) from your carton dimensions—useful for quotes, consolidation, and planning
              shipment space.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="svc-shell">
        <div className="svc-cbm-panel">
          <CbmCalculator title="Shipment volume (CBM)" />
        </div>
      </div>
    </div>
  );
};

export default CbmCalculatorPage;
